export const registryPageData = {
  seoText: 'Online Wedding Registry with Major Retailers and Cash Registries | Joy',
  title: 'And remember,<br/>we’re always here for you.',
  content: 'Chat with the best customer service team in weddings —<br/>we’re here to make sure you get to the big day without the fray.',
  quote: 'I get paid to help people in love — it doesn’t get better than that!',
  caption: 'Jane Doe, Team Member since 2015',
  seo: {
    title: 'Wedding Registry & Gift Finder | Joy - Wedding Registry',
    content:
      'Create your Joy wedding registry to add gifts from Joy’s shop or any online retailer, along with zero-fee cash funds, honeymoon experiences, and more. Build your wedding registry!',
  },
  rethinkRegistrySection: {
    mainTextTitle: 'Fast, flexible, and free.',
    mainTextBody: 'Give guests one convenient place to shop. Manage and track all your gifts in one place.',
    featureList: [
      {
        image: 'registry-v2/registry-features/icon-wand.svg',
        title: 'Add Gifts from Any Store',
        body: 'Add items from Joy’s catalog or your favorite stores with the Browser Button and mobile app.',
      },
      {
        image: 'registry-v2/registry-features/icon-one-registry.svg',
        title: 'Connect Any Registry',
        body: 'Sync or link all your registries to Joy, giving guests one place to shop from your site.',
      },
      {
        image: 'registry-v2/registry-features/icon-no-fees.svg',
        title: 'Zero-Fee Cash Funds',
        body: 'Save for your dreams faster with our zero-fee cash registry.',
      },
      {
        image: 'registry-v2/registry-features/icon-registry-mobile.svg',
        title: 'Shop on the Go',
        body: 'Quickly add gifts wherever you are, so you never forget to add that must-have item.',
      },
    ],
  },
  publicCatalogSection: {
    eyebrow: 'The Joy Shop',
    title: 'Wrap up your registry with the perfect gifts.',
    body: 'Shop by Department',
    departmentIconList: [
      {
        icon: 'kitchen',
        text: 'Kitchen',
        url: 'https://withjoy.com/shop/catalog/kitchen',
      },
      {
        icon: 'bar',
        text: 'Table & Bar',
        url: 'https://withjoy.com/shop/catalog/tabletop',
      },
      {
        icon: 'bed',
        text: 'Bed & Bath',
        url: 'https://withjoy.com/shop/catalog/bed-bath',
      },
      {
        icon: 'home',
        text: 'Home',
        url: 'https://withjoy.com/shop/catalog/home',
      },
      {
        icon: 'travelbag',
        text: 'Lifestyle',
        url: 'https://withjoy.com/shop/catalog/lifestyle',
      },
      {
        icon: 'cashfunds',
        text: 'Cash Funds',
        url: 'https://withjoy.com/shop/catalog/cash-funds',
      },
      {
        icon: 'charity',
        text: 'Charity',
        url: 'https://withjoy.com/shop/catalog/charity',
      },
      {
        icon: 'experiences',
        text: 'Experiences',
        url: 'https://withjoy.com/shop/catalog/experiences',
      },
    ],
    catlogList: [
      {
        image: 'registry-v2/public-catalog/product-oven-2.jpg',
        title: 'Le Creuset',
        body: 'Signature Cast-Iron Round Dutch Oven',
        url: 'https://withjoy.com/shop/item/de42b69c-070f-51bd-991b-673eb1c9a014',
      },
      {
        image: 'registry-v2/public-catalog/product-airbnb-3.jpg',
        title: 'Airbnb',
        body: 'Airbnb Gift Card',
        url: 'https://withjoy.com/shop/item/36e71fb5-0ce2-5539-87a2-b14a16335c9f',
      },
      {
        image: 'registry-v2/public-catalog/product-mixer-3-v3.jpg',
        title: 'KitchenAid',
        body: '5 QT Artisan Stand Mixer',
        url: 'https://withjoy.com/shop/item/1ef42273-086f-5f1b-adf6-903fcf0b4415',
      },
      {
        image: 'registry-v2/public-catalog/product-yeti-5.jpg',
        title: 'YETI',
        body: 'Hopper Portable Cooler',
        url: 'https://withjoy.com/shop/item/d9ebc614-d265-5284-a3b5-07c036ae9440',
      },
      {
        image: 'registry-v2/public-catalog/product-pan-6.jpg',
        title: 'Calphalon',
        body: 'Classic Non Stick Fry Pan Set',
        url: 'https://withjoy.com/shop/item/30c2b962-84ca-5e3a-88dc-1cc75c74d2c6',
      },
      {
        image: 'registry-v2/public-catalog/product-flutes-6.jpg',
        title: 'Riedel',
        body: 'Vinum Cuvee Prestige Wine Glass. Set of 2',
        url: 'https://withjoy.com/shop/item/21365aaa-3f02-5d4d-9f35-8deb3a049314',
      },
    ],
    exploreShopButton: {
      label: 'Explore the Shop',
      url: 'https://www.withjoy.com/shop',
    },
  },
  registryCrossSection: {
    eyebrow: 'The Best Part',
    title: 'Every registry comes with Joy.',
    body:
      'With beautiful wedding websites, matching save the dates and invites, powerful planning tools, and always-on customer support, see why Joy is the smarter way to plan your big day.',
    getStarted: 'Get Started',
    featuresData: [
      {
        image: 'honeymoon-fund/icon-website-v2.svg',
        title: 'Free Wedding</br>Websites',
      },
      {
        image: 'honeymoon-fund/icon-cards-v2.svg',
        title: 'Save the Dates, Invites & Matching Prints',
      },
      {
        image: 'honeymoon-fund/icon-wand-v2.svg',
        title: 'Powerful</br>Planning Tools',
      },
      {
        image: 'honeymoon-fund/icon-support-v2.svg',
        title: 'Personal</br>Customer Support',
      },
    ],
  },
  universalRegistrySection: {
    eyeBrow: 'Your Universal Registry',
    title: 'All your registries in one place.',
    content:
      'Add items from your favorite stores, and even connect existing registries, to give guests one convenient place to shop. That’s easy for you and easy for your guests.',
    madeItEasier: 'We’ve made it better to give <em>and</em> receive.',
    getStarted: 'Get Started',
    registryItemImageAlt: 'Registry item',
    registryTypeGifts: 'Gifts',
    registryTypeCash: 'Cash Funds',
    registryTypeExperiences: 'Experiences',
    registryTypeCharity: 'Charity',
  },
  emotionalBreak: {
    title: 'Designed to let you focus on what matters.',
    altText: 'Image of couple dancing in an aquarium',
  },
  sections: {
    faqList: {
      title: 'Still have questions?',
    },
    stats: {
      title: 'We’ve helped millions celebrate love around the world.',
      subtitle: 'That’s more cake, flowers and happy tears than we can count.',
      data: [
        {
          title: 'million',
          body: 'The largest guest list in Joy',
          endingNumber: 8,
          incrementFrequency: 150,
        },
        {
          title: 'countries',
          body: 'Screaming babies have interrupted weddings on',
          endingNumber: 86,
          incrementFrequency: 100,
        },
        {
          title: 'guests',
          body: 'People around the world',
          endingNumber: 768,
          incrementFrequency: 20,
        },
      ],
    },
  },
  shopRegistry: {
    subTitle: 'Over 10,000+ items from all the best brands.',
    shopTitle: 'Shop Registry by Department',
  },
  shopSearch: {
    title: 'Shop with Joy, today.',
    subTitle: 'Gifts, experiences, cash-funds and more',
    placeHolder: 'Search brands, products, and more',
    submitLabel: 'Search',
  },
  registryHero: {
    title: 'The everything wedding registry.',
    features: [
      'Shop Joy and all your favorite retailers in one place',
      'Create unlimited cash funds with zero-fees',
      'Add gifts from any store and share with one link',
      'One-on-one support for you and your guests',
    ],
    cta1Label: 'Start Your Free Registry',
    cta2Label: 'Find a Couple',
  },
  shopSection: {
    title: 'Find the gifts you want.',
    subTitle: 'Shop the best brands from Joy and any of your favorite stores all in one place.',
    productSectionTitle: 'Shop the best brands\nwith Joy, today.',
    productSectionSubTitle:
      'We carry gifts for the every couple and every budget. Tens of thousands of the best products shipped directly to you.',
    productSectionCTA: 'Shop with Joy',
    universalSearchCard: {
      eyebrow: 'Universal Search',
      title: 'Search and add \nanything in one place.',
      searchAnyStore: 'Search any store',
      search: 'Search',
    },
    oneRegistryCard: {
      eyebrow: 'One registry',
      title: 'Add anything from any\nstore. Literally.',
      learnMoreCTA: 'Learn More',
      modalContent: [
        {
          eyebrow: 'Joy Browser Button',
          title: 'Install our simple browser tool that lets you add gifts from any website.',
          src: '/registry-q12024/learn-more-addanything/hero-addanything-00@2x.png',
        },
        {
          eyebrow: 'Mobile App',
          title: 'Shop Joy and add gifts from your favorite online stores right from your mobile phone.',
          src: '/registry-q12024/learn-more-addanything/hero-addanything-01@2x.png',
        },
        {
          eyebrow: 'Universal Search',
          title: 'If we don’t have it, search all your favorite stores in one place and add it to your registry.',
          src: '/registry-q12024/learn-more-addanything/hero-addanything-03@2x.png',
        },
        {
          eyebrow: 'Universal Registry',
          title: 'All your favorite retailers in one simple registry for guests.',
          src: '/registry-q12024/learn-more-addanything/hero-addanything-04@2x.png',
        },
        {
          eyebrow: 'One Seamless Shopping Experience',
          title: 'Buy from Joy and all your favorite retailers in one place. No more link-outs.',
          src: '/registry-q12024/learn-more-addanything/hero-addanything-05@2x.png',
        },
      ],
    },
    curationCard: {
      eyebrow: 'Honest Collections',
      title: 'What to register for\nfrom the experts',
    },
  },
  registryCashFundSection: {
    title: 'The registry that does more.',
    body: 'There are just some things Amazon or Crate & Barrel won’t let you do.',
    features: [
      {
        title: 'Easy Shipping & Returns',
        body: 'We offer free shipping and hassle free returns for you and your guests on all items sold by Joy Shop.',
        iconName: 'freeShipping',
      },
      {
        title: '20% Off Newly Wed Discounts',
        body: 'Get 20% newly-wed discounts on everything on your registry after your wedding day.',
        iconName: 'tag',
      },
      {
        title: 'Gifts for Cash',
        body: 'Swap gifts for cash on all items you add to your registry from other stores such as Amazon or Crate and Barrel.',
        iconName: 'discountCode',
      },
    ],
    shipInfoCard: {
      eyebrow: 'Ship When You Want',
      title: 'Don’t miss that package while you’re honeymoon-ing.',
    },
    groupGiftingCard: {
      eyebrow: 'Group Gifting',
      title: 'Guests can chip in together to get you something special.',
      progressLabel: '$4000 Goal',
    },
    cC4CashCard: {
      eyebrow: 'Credit Cards for Cash Funds',
      title: 'Allow your guests to contribute to your Cash funds their way.',
    },
    cashFundCard: {
      title: 'Zero-Fee Cash Funds',
      body:
        'Save for your dreams faster and skip the credit card fees by easily contributing using Venmo, PayPal, and CashApp with zero fees.',
      learnMoreCTA: 'Learn More',
      path: '/honeymoon-registry',
    },
  },
  guestExperienceSection: {
    title: 'A better experience for guests.',
    body: 'From your own registry page to live one-on-one support. It’s a seamless experience for guests.',
    accountCard: {
      eyebrow: 'No Accounts Required',
      title: 'Unlike most, with Joy, guests don’t need an account to purchase.',
    },
    checkOutExperienceCard: {
      title: 'One seamless checkout experience',
      body: 'Customize your own wedding registry site that lets guests shop everything from one place. (It also matches your website).',
    },
    liveSupportCard: {
      eyebrow: 'Live Support for Guests',
      title: 'Here for your guests every step of the way.',
    },
  },
  supportSection: {
    title: 'One-on-One Support with Joy',
    body: 'From help with what to add, hassle-free returns to <b>guaranteed price matching</b> - we’re here every step of the way.',
  },
  registryFaqSection: {
    title: 'Frequently Asked Questions',
    body: 'Take a look at our most commonly asked questions and answers. For additional support chat with us.',
  },
  registryThankYouNoteSection: {
    title: 'Automagic Thank You Notes',
    body: 'We’ll keep a list of who sent what so you can send free, online thank you notes right.',
    button: 'Watch the Video',
    bannerVideoTitle: 'Registry Thank You Notes Banner',
    videoTitle: 'Registry Thank You Notes Video',
  },
} as const;
